// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Progress,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";

import BarChart from "components/Charts/BarChart";
import LineChart from "components/Charts/LineChart";
import IconBox from "components/Icons/IconBox";

// Custom icons
import {
  CartIcon,
  DocumentIcon,
  GlobeIcon,
  WalletIcon,
  MoneyTotal,
} from "components/Icons/Icons.js";
import React, { useState, useEffect } from "react";
// Variables
import {
  barChartData,
  barChartOptions,
  lineChartData,
  lineChartOptions,
} from "variables/charts";
import { pageVisits, socialTraffic } from "variables/general";
import { tablesProjectData, tablesTableData } from "variables/general";

export default function Dashboard() {
  // Chakra Color Mode
  const iconBlue = useColorModeValue("yellow.500", "yellow.500");
  const iconBoxInside = useColorModeValue("white", "white");
  const textColor = useColorModeValue("gray.700", "white");
  const tableRowColor = useColorModeValue("#F7FAFC", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const textTableColor = useColorModeValue("gray.500", "white");

  const { colorMode } = useColorMode();

  const [isOpen, SetIsOpen] = useState(false);

  const [saldo, setSaldo] = useState(0);
  const [trafico, setTrafico] = useState(0);
  const [referidos, setReferidos] = useState(0);
  const [clients, setClients] = useState(0);
  const [ultimos, setUltimos] = useState([]);
  const [totaltraffic, setTotaltraffic] = useState({
    facebook: 0,
    porcentajef: 0,
    instagram: 0,
    porcentajei: 0,
    whatsapp: 0,
    porcentajew: 0,
    directlink: 0,
    porcentajel: 0,
    total: 0,
  });

  const onClose = () => {
    SetIsOpen(false);
  };

  const obtenerultimos = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/verultimoswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          setUltimos(result);
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setSaldo(parseFloat(result.message));
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenersaldo = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/versaldowill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setSaldo(parseFloat(result.message));
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenertrafico = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/vertraficowill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setTrafico(parseFloat(result.message));
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenerreferidos = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/verreferidoswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setReferidos(parseFloat(result.message));
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenerclients = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/verclienteswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          console.log("LLEGO AQUI");
          console.log(result);
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setClients(result.message);
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenertotales = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/totalvisitaswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log(result.facebook);
        if (result.message) {
          console.log(result.message);
        } else {
          setTotaltraffic(result);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenerporcen = (valor, total) => {
    // Cálculo del porcentaje
    let porcentaje = (valor / total) * 100;
    console.log(valor, total);
    return parseInt(porcentaje);
  };

  const obtenertoken = () => {
    const isAuthenticated = localStorage.getItem("token_royal");

    console.log(window.location.hash);
    if (!isAuthenticated) {
      window.location.href = "/#/auth/signin";
      window.location.reload();
    }
  };

  useEffect(() => {
    obtenertoken();
    obtenersaldo();
    obtenertrafico();
    obtenerreferidos();
    obtenerclients();
    obtenertotales();
    obtenerultimos();
  }, []);

  useEffect(() => {
    console.log(ultimos);
  }, [ultimos]);

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing="24px" mb="20px">
        <Card minH="125px">
          <Flex direction="column">
            <Flex
              flexDirection="row"
              align="center"
              justify="center"
              w="100%"
              mb="25px"
            >
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color="gray.400"
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  Saldo Actual
                </StatLabel>
                <Flex>
                  <StatNumber fontSize="lg" color={textColor} fontWeight="bold">
                    ${saldo}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox
                borderRadius="50%"
                as="box"
                h={"45px"}
                w={"45px"}
                bg={iconBlue}
              >
                <WalletIcon h={"24px"} w={"24px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color="gray.400" fontSize="sm">
              <Text as="span" color="green.400" fontWeight="bold">
                30$
              </Text>{" "}
              Min Cashout
            </Text>
          </Flex>
        </Card>
        <Card minH="125px">
          <Flex direction="column">
            <Flex
              flexDirection="row"
              align="center"
              justify="center"
              w="100%"
              mb="25px"
            >
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color="gray.400"
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  Link Tracking
                </StatLabel>
                <Flex>
                  <StatNumber fontSize="lg" color={textColor} fontWeight="bold">
                    {trafico}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox
                borderRadius="50%"
                as="box"
                h={"45px"}
                w={"45px"}
                bg={iconBlue}
              >
                <GlobeIcon h={"24px"} w={"24px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color="gray.400" fontSize="sm">
              <Text as="span" color="green.400" fontWeight="bold">
                Total Visitas
              </Text>
            </Text>
          </Flex>
        </Card>
        <Card minH="125px">
          <Flex direction="column">
            <Flex
              flexDirection="row"
              align="center"
              justify="center"
              w="100%"
              mb="25px"
            >
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color="gray.400"
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  Referrals
                </StatLabel>
                <Flex>
                  <StatNumber fontSize="lg" color={textColor} fontWeight="bold">
                    {referidos}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox
                borderRadius="50%"
                as="box"
                h={"45px"}
                w={"45px"}
                bg={iconBlue}
              >
                <DocumentIcon h={"24px"} w={"24px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color="gray.400" fontSize="sm">
              <Text as="span" color="green.500" fontWeight="bold">
                Total Referidos
              </Text>
            </Text>
          </Flex>
        </Card>
        <Card minH="125px">
          <Flex direction="column">
            <Flex
              flexDirection="row"
              align="center"
              justify="center"
              w="100%"
              mb="25px"
            >
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color="gray.400"
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  Your Earnings
                </StatLabel>
                <Flex>
                  <StatNumber fontSize="lg" color={textColor} fontWeight="bold">
                    ${clients}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox
                borderRadius="50%"
                as="box"
                h={"45px"}
                w={"45px"}
                bg={iconBlue}
              >
                <CartIcon h={"24px"} w={"24px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color="gray.400" fontSize="sm">
              <Text as="span" color="green.400" fontWeight="bold">
                Total Ganado
              </Text>{" "}
            </Text>
          </Flex>
        </Card>
      </SimpleGrid>
      <Flex direction="column">
        <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
          <CardHeader p="6px 0px 22px 0px">
            <Text fontSize="xl" color={textColor} fontWeight="bold">
              Ultimos Referidos
            </Text>
          </CardHeader>
          <CardBody>
            {ultimos.length == 0 ? (
              <div align="center" style={{ padding: "20px" }}>
                <Stat me="auto">
                  <StatLabel
                    fontSize="xs"
                    color="gray.400"
                    fontWeight="bold"
                    textTransform="uppercase"
                  >
                    No referrals registered
                  </StatLabel>
                </Stat>
              </div>
            ) : (
              <Table variant="simple" color={textColor}>
                <Thead>
                  <Tr my=".8rem" pl="0px" color="gray.400">
                    <Th pl="0px" borderColor={borderColor} color="gray.400">
                      Name
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Location
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Status
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Registro
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {ultimos.map((row, index, arr) => {
                    return (
                      <TablesTableRow
                        name={row.Nombres}
                        logo={row.ImagenBag}
                        subdomain={row.Estado}
                        domain={row.Pais}
                        status={row.Estatus}
                        date={row.Fecha}
                        isLast={index === arr.length - 1 ? true : false}
                        key={index}
                      />
                    );
                  })}
                </Tbody>
              </Table>
            )}
          </CardBody>
        </Card>
        <Card my="22px" overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
          <CardHeader p="6px 0px 22px 0px">
            <Flex direction="column">
              <Text
                fontSize="lg"
                color={textColor}
                fontWeight="bold"
                pb=".5rem"
              >
                Social traffic
              </Text>
            </Flex>
          </CardHeader>
          <CardBody>
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" pl="0px">
                  <Th pl="0px" color="gray.400" borderColor={borderColor}>
                    Referral
                  </Th>
                  <Th color="gray.400" borderColor={borderColor}>
                    Visitors
                  </Th>

                  <Th color="gray.400" borderColor={borderColor}></Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                <TablesProjectRow
                  name="Facebook"
                  logo="Facebook"
                  status=""
                  budget={totaltraffic.facebook}
                  progression={totaltraffic.porcentajef}
                  isLast="1"
                  colorbarra="blue"
                />
                <TablesProjectRow
                  name="Instagram"
                  logo="Instagram"
                  status=""
                  budget={totaltraffic.instagram}
                  progression={totaltraffic.porcentajei}
                  isLast="1"
                  colorbarra="red"
                />
                <TablesProjectRow
                  name="Whatsapp"
                  logo="Whatsapp"
                  status=""
                  budget={totaltraffic.whatsapp}
                  progression={totaltraffic.porcentajew}
                  isLast="1"
                  colorbarra="green"
                />
                <TablesProjectRow
                  name="Direct Link"
                  logo="Direct Link"
                  status=""
                  budget={totaltraffic.directlink}
                  progression={totaltraffic.porcentajel}
                  isLast="1"
                  colorbarra="yellow"
                />
              </Tbody>
            </Table>
          </CardBody>
        </Card>
      </Flex>
    </Flex>
  );
}
